export default {
  title: '隐私政策管理',
  menu: '隐私政策管理',
  ajingaPolicyManagement: '菁客隐私政策管理',
  label: {
    createTime: '创建日期',
    policyZhName: '协议名（中文）',
    policyEnName: '协议名（英文）',
    policyType: '协议类型',
    policyCreator: '创建人',
    policyOpenStatus: '启用状态',
    policyOperate: '操作',
    PRIVACY: '菁客隐私政策',
    TOS: '菁客用户协议',
    createAgreementTitle: '新建',
    viewAgreementTitle: '查看',
    editAgreementTitle: '编辑',
    agreementCategory: '协议类别',
    agreementCnContent: '协议（中文）',
    agreementEnContent: '协议（英文）',
    agreementStyle: '协议样式',
    statementPreview: '申请按钮上方',
    statePreviewTitle: '在申请按钮上方直接显示协议名称。',
    example: '例如：',
    statementPop: '弹窗式',
    statementPopTitle: '求职者点击申请按钮后，弹窗显示协议内容，适用于有多条协议情况。',
    agreementCnName: '协议文案（中文）',
    agreementEnName: '协议文案（英文）',
    agreementType: '协议类型',
    agreementFile: '协议附件',
    link: '超链接',
    file: '文件',
    text: '文本',
    agreementCn: '（中文）',
    agreementEn: '（英文）',
    uploadTip: '将文件拖到此处，或',
    clickUpload: '点击上传',
    uploadCheck: '只能上传PDF文件，且不能超过3MB',
    addStatementPopAgreement: '新增一条协议',
    popTitle: '弹窗标题',
    chinese: '中文',
    english: '英文',
    acceptBtn: '同意按钮',
    declineBtn: '拒绝按钮',
    notification: '活动订阅同意',
    satisfaction: '满意度调查同意',
    required: '是否必选',
    yes: '是',
    no: '否',
    uploadingText: '文件上传中',
    uploadingFinish: '文件上传成功',
    uploadHere: '上传',
    selectFileUpload: '请选择文件上传',
    employeeAgreed: '我知晓',
    employeeRegisterPolicy: '杰尼亚大中华区内部推荐政策',
    revokeEmailAddress: '候选人撤回申请发送通知邮件至'
  },
  placeholder: {

  },
  btn: {
    viewPolicy: '查看',
    editPolicy: '编辑',
    deletePolicy: '删除',
    addNewVersion: '添加',
    confirm: '确定',
    cancel: '取消'
  },
  message: {
    updateEnabled: '更新成功',
    deleteOrNot: '此操作将永久删除该协议, 是否继续?',
    updateEnable: '开启后该协议将不可编辑，是否继续？',
    deletePoint: '提示',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败',
    deleteCancel: '已取消删除',
    updateSuccess: '更新成功',
    createSuccess: '创建成功',
    cancelEnabled: '已取消更改',
    copyFileUrl: {
      success: '复制链接成功',
      fail: '复制链接失败'
    },
    deletePolicyFileError: '该链接已被使用，请先删除被使用处。',
    fileTypeError: '只能上传10MB以内的文件，支持以下格式：\'pdf\', \'doc\', \'docx',
    fileSizeError: '文件大小必须小于10Mb',
    notClosePolicy: '无法停用，须确保系统有且仅有一条该类型协议已启用。',
    employeeAgreePolicyWarning: '请同意协议',
    onlyOneNotification: '只能配置一条活动订阅同意',
    onlyOneSatisfaction: '只能配置一条满意度调查订阅同意',
    consentUpdated: '请阅读并同意最新版本协议'
  }
}
